"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tokens_1 = require("../static/tokens");

var network_1 = require("../static/network");

var bignumber_js_1 = require("bignumber.js");

var qs = require("qs");

var node_fetch_1 = __importDefault(require("node-fetch"));

var magic_data_1 = require("./magic-data");

var ethers_1 = require("ethers");

var multi_op_1 = require("./multi-op");

var utils_1 = require("../util/utils");

var ZeroEx =
/** @class */
function () {
  function ZeroEx() {}

  ZeroEx.getSwap = function (network, sellToken, buyToken, buyAmount, gasPrice) {
    return __awaiter(this, void 0, void 0, function () {
      var params, swapUrl, res, quote;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params = {
              sellToken: tokens_1.Token[sellToken],
              buyToken: tokens_1.Token[buyToken],
              buyAmount: buyAmount.toFixed()
            };

            if (gasPrice != undefined) {
              params.gasPrice = utils_1.Utils.normalizeNumber(gasPrice).toFixed();
            }

            swapUrl = ZeroEx.getSwapUrl(network);
            return [4
            /*yield*/
            , node_fetch_1["default"](swapUrl + "/quote?" + qs.stringify(params))];

          case 1:
            res = _a.sent();
            return [4
            /*yield*/
            , res.json()];

          case 2:
            quote = _a.sent();
            return [2
            /*return*/
            , [{
              to: quote.to,
              data: quote.data,
              value: new bignumber_js_1.BigNumber(quote.value)
            }, new bignumber_js_1.BigNumber(quote.gasPrice), new bignumber_js_1.BigNumber(quote.protocolFee)]];
        }
      });
    });
  };

  ZeroEx.getSwapUrl = function (network) {
    switch (network) {
      case network_1.Network.Mainnet:
        return 'https://api.0x.org/swap/v0';

      case network_1.Network.Kovan:
        return 'https://api.0x.org/swap/v0';

      default:
        throw "Unsupported network";
    }
  };

  ZeroEx.injectSwapToData = function (data, invocation) {
    return __awaiter(this, void 0, void 0, function () {
      var swapData;
      return __generator(this, function (_a) {
        swapData = multi_op_1.MultiInvocationFormatter.formatMultiInvocation(true, [invocation]);
        return [2
        /*return*/
        , this.replaceData(data, swapData)];
      });
    });
  };

  ZeroEx.replaceData = function (data, replaceData) {
    var magicDataLength = ethers_1.ethers.utils.hexZeroPad(ZeroEx.ap(ZeroEx.hl(magic_data_1.MAGIC_DATA).toString(16)), 32);
    var findData = ZeroEx.sp(magicDataLength) + ZeroEx.sp(magic_data_1.MAGIC_DATA);

    if (!data.includes(findData)) {
      throw "REPLACE_BY_SWAP marker not passed in";
    }

    var replaceDataLength = ethers_1.ethers.utils.hexZeroPad(ZeroEx.ap(ZeroEx.hl(replaceData).toString(16)), 32);
    var finalReplaceData = ZeroEx.sp(replaceDataLength) + ZeroEx.sp(replaceData);
    return data.replace(findData, finalReplaceData);
  };

  ZeroEx.sp = function (hex) {
    return hex.replace("0x", "");
  };

  ZeroEx.ap = function (hex) {
    return "0x" + ZeroEx.sp(hex);
  };

  ZeroEx.hl = function (hex) {
    return ZeroEx.sp(hex).length / 2;
  };

  ZeroEx.SWAP_BUFFER_BIPS = new bignumber_js_1.BigNumber(100);
  return ZeroEx;
}();

exports.ZeroEx = ZeroEx;